import api from './api';
import { SafeCode, CreateSafeCodeDto, UpdateSafeCodeDto, CreateAccessCodeDto, AccessCode, VerifySafeCodeDto } from '../types/safe-code.types';

class SafeCodeService {
  private baseUrl = '/safe-codes';

  async getAllSafeCodes(): Promise<SafeCode[]> {
    const response = await api.get<SafeCode[]>(this.baseUrl);
    return response.data;
  }

  async getSafeCode(id: number): Promise<SafeCode> {
    const response = await api.get<SafeCode>(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async createSafeCode(data: CreateSafeCodeDto): Promise<SafeCode> {
    const response = await api.post<SafeCode>(this.baseUrl, data);
    return response.data;
  }

  async updateSafeCode(id: number, data: UpdateSafeCodeDto): Promise<SafeCode> {
    const response = await api.patch<SafeCode>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async deleteSafeCode(id: number): Promise<void> {
    await api.delete(`${this.baseUrl}/${id}`);
  }

  // Методы для работы с кодами доступа
  async createAccessCode(safeCodeId: number, data: Omit<CreateAccessCodeDto, 'safeCodeId'>): Promise<AccessCode> {
    const response = await api.post<AccessCode>(`${this.baseUrl}/${safeCodeId}/access-codes`, data);
    return response.data;
  }

  async getAccessCodes(safeCodeId: number): Promise<AccessCode[]> {
    const response = await api.get<AccessCode[]>(`${this.baseUrl}/${safeCodeId}/access-codes`);
    return response.data;
  }

  async deleteAccessCode(id: number): Promise<void> {
    await api.delete(`${this.baseUrl}/access-codes/${id}`);
  }

  // Метод для проверки кода
  async verifySafeCode(data: VerifySafeCodeDto): Promise<{ success: boolean; prizeName?: string }> {
    const response = await api.post<{ success: boolean; prizeName?: string }>(`${this.baseUrl}/verify`, data);
    return response.data;
  }
}

export const safeCodeService = new SafeCodeService();
